const arr =[{
	path:'details',
	component: resolve => {
		require(['../../../views/inner/product/opinion/details.vue'], resolve)
	}
},
{
	path:'list',
	component: resolve => {
		require(['../../../views/inner/product/opinion/list.vue'], resolve)
	}
}]

export default arr


// WEBPACK FOOTER //
// ./src/router/inner/product/opinion.js